<div
  [formGroup]="formGroup"
  *ngIf="formGroup"
  class="filter-dropdown-container w-full"
  [class.embedded]="isEmbedded"
>
  <!-- Trigger Button -->
  <button
    *ngIf="!isEmbedded"
    #triggerButton
    type="button"
    class="filter-trigger-btn flex items-center justify-between border border-gray-300 dark:border-gray-600 rounded-md transition-all duration-150"
    (click)="toggleDropdown($event)"
  >
    <div class="flex items-center gap-2">
      <!-- Filter Icon -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        class="w-4 h-4 text-gray-500 dark:text-gray-400"
      >
        <path
          fill-rule="evenodd"
          d="M2.628 1.601C5.028 1.206 7.49 1 10 1s4.973.206 7.372.601a.75.75 0 0 1 .628.74v2.288a2.25 2.25 0 0 1-.659 1.59l-4.682 4.683a2.25 2.25 0 0 0-.659 1.59v3.037c0 .684-.71 1.13-1.316.814l-3.036-1.518A1 1 0 0 1 7.155 13V9.754a2.25 2.25 0 0 0-.659-1.59L1.814 3.481A2.25 2.25 0 0 1 1.155 1.89V2.34a.75.75 0 0 1 .628-.74v-.739Z"
          clip-rule="evenodd"
        />
      </svg>
      <span class="text-sm font-semibold text-gray-700 dark:text-gray-200">{{
        triggerLabel
      }}</span>
      <span
        *ngIf="getTotalSelectedCount() > 0"
        class="selected-badge flex items-center justify-center bg-blue-500 text-white rounded-full text-xs font-bold w-5 h-5"
      >
        {{ getTotalSelectedCount() }}
      </span>
    </div>
    <span class="arrow" [class.open]="isOpen"></span>
  </button>

  <!-- Dropdown Panel -->
  <div
    #dropdownPanel
    class="filter-dropdown-panel bg-white dark:bg-coal-700 border border-gray-200 dark:border-gray-600 rounded-lg shadow-xl"
    [class.embedded-panel]="isEmbedded"
    [style.display]="isOpen ? 'block' : 'none'"
    [style.position]="isEmbedded ? 'relative' : 'absolute'"
    [style.width]="isEmbedded ? '100%' : '480px'"
    (click)="$event.stopPropagation()"
  >
    <!-- Header (Tabs & Save actions) -->

    <!-- Multi-Column Body -->
    <div class="filter-body flex">
      <!-- Left List (Fields list) -->
      <div
        class="fields-list-pane border-r border-gray-300 dark:border-gray-800 flex flex-col justify-between bg-white dark:bg-coal-500"
      >
        <div
          class="fields-list-scroll flex flex-col gap-0.5 py-2 flex-1 overflow-y-auto"
        >
          <div
            *ngFor="let field of formFields"
            class="field-list-item flex items-center justify-between px-3 py-2 cursor-pointer transition-colors duration-150"
            [class.active]="activeField?.fieldName === field.fieldName"
            (click)="selectField(field)"
          >
            <span
              class="field-name-text text-2sm font-medium text-gray-600 dark:text-gray-300 truncate"
            >
              {{ field.mappingColumnHeader || field.displayName }}
            </span>
            <!-- Selected Count Badge -->
            <span
              *ngIf="getSelectedCount(field) > 0"
              class="field-count-badge text-xs font-semibold"
            >
              {{ getSelectedCount(field) }}
            </span>
          </div>
        </div>
      </div>

      <!-- Right List (Options List with Search) -->
      <div class="options-pane flex-1 flex flex-col bg-white dark:bg-coal-500">
        <!-- Search Input -->
        <div
          *ngIf="!isDateRangeField(activeField)"
          class="search-wrapper border-b border-gray-200 dark:border-gray-600 bg-white dark:bg-coal-500"
        >
          <div class="search-input-container">
            <span class="search-icon"></span>
            <input
              type="text"
              class="search-input bg-white dark:bg-coal-500 text-gray-700 dark:text-gray-200"
              [placeholder]="
                'Search ' +
                ((
                  activeField?.mappingColumnHeader || activeField?.displayName
                )?.toLowerCase() || 'options')
              "
              [ngModel]="searchTerms[activeField?.fieldName || ''] || ''"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="onSearchChange(activeField, $event)"
              (keydown.escape)="closeDropdown()"
              (keydown.enter)="
                $event.preventDefault(); $event.stopPropagation()
              "
            />
            <button
              *ngIf="searchTerms[activeField?.fieldName || '']"
              type="button"
              class="clear-btn text-xl text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
              (click)="onSearchChange(activeField, '')"
            >
              ×
            </button>
          </div>
        </div>

        <!-- Scrollable Options List -->
        <div
          *ngIf="!isDateRangeField(activeField)"
          class="options-list-container flex-1 overflow-y-auto max-h-64 py-1"
          (scroll)="onScroll($event)"
        >
          <!-- Loading State -->
          <div
            *ngIf="loadingFields[activeField?.fieldName || '']"
            class="flex justify-center items-center py-6 text-gray-500 dark:text-gray-400 text-2sm gap-2"
          >
            <!-- Spinner -->
            <svg
              class="animate-spin h-4 w-4 text-blue-500"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              ></circle>
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
            Loading...
          </div>

          <!-- Options -->
          <ng-container *ngIf="!loadingFields[activeField?.fieldName || '']">
            <div
              *ngFor="let option of optionsData[activeField?.fieldName || '']"
              class="option-item flex items-center gap-2.5 px-3 py-2 cursor-pointer transition-colors duration-150 hover:bg-gray-50 dark:hover:bg-gray-700/40 text-gray-700 dark:text-gray-200"
              (click)="toggleOption(activeField, option)"
            >
              <!-- Checkbox -->
              <input
                type="checkbox"
                [checked]="isSelected(activeField, option)"
                (click)="
                  toggleOption(activeField, option); $event.stopPropagation()
                "
                class="cursor-pointer checkbox checkbox-2sm"
              />

              <!-- Avatar / Icon / Color Indicator -->
              <ng-container
                *ngIf="
                  activeField?.fieldName === 'assigned' ||
                    activeField?.fieldName === 'owners' ||
                    activeField?.fieldName === 'assignee';
                  else defaultIcon
                "
              >
                <img
                  *ngIf="hasValidPhoto(option.profilePhoto)"
                  [src]="option.profilePhoto"
                  (error)="handleImageError($event)"
                  alt="Profile"
                  class="w-7 h-7 rounded-full object-cover"
                />
                <div
                  *ngIf="!hasValidPhoto(option.profilePhoto)"
                  class="avatar-circle flex items-center justify-center text-white text-2xs font-semibold rounded-full w-7 h-7"
                  [style.background-color]="
                    getAvatarColor(getOptionText(activeField, option))
                  "
                >
                  {{ getInitials(getOptionText(activeField, option)) }}
                </div>
              </ng-container>

              <!-- Priority / Risk / Status: render color coded bullet/tag if color is present -->
              <ng-template #defaultIcon>
                <span
                  *ngIf="option.color"
                  class="color-dot rounded-full w-2.5 h-2.5 flex-shrink-0"
                  [style.background-color]="option.color"
                ></span>
              </ng-template>

              <!-- Option Label Text -->
              <div
                class="flex flex-col min-w-0"
                *ngIf="
                  activeField?.fieldName === 'assigned' ||
                    activeField?.fieldName === 'owners' ||
                    activeField?.fieldName === 'assignee';
                  else defaultLabel
                "
              >
                <span
                  class="text-2sm font-medium text-gray-800 dark:text-gray-200 truncate"
                >
                  {{ getOptionText(activeField, option) }}
                </span>
                <span
                  *ngIf="option.email"
                  class="text-2xs text-gray-400 dark:text-gray-500 font-normal truncate"
                >
                  {{ option.email }}
                </span>
              </div>
              <ng-template #defaultLabel>
                <span class="text-2sm font-medium">
                  {{ getOptionText(activeField, option) }}
                </span>
              </ng-template>
            </div>

            <!-- Empty State -->
            <div
              *ngIf="
                !optionsData[activeField?.fieldName || ''] ||
                optionsData[activeField?.fieldName || '']?.length === 0
              "
              class="no-data text-center py-6 text-gray-400 dark:text-gray-500 text-2sm"
            >
              No options found
            </div>
          </ng-container>
        </div>

        <!-- Date Range Panel -->
        <div
          *ngIf="isDateRangeField(activeField)"
          class="date-range-pane flex-1 flex flex-col p-2 overflow-y-auto"
        >
          <!-- Presets row -->
          <div class="preset-buttons-row grid grid-cols-4 gap-2 w-full">
            <button
              type="button"
              class="preset-btn"
              [class.active]="selectedDatePreset === 'today'"
              (click)="applyDatePreset('today')"
            >
              Today
            </button>
            <button
              type="button"
              class="preset-btn"
              [class.active]="selectedDatePreset === 'last7'"
              (click)="applyDatePreset('last7')"
            >
              Last 7 Days
            </button>
            <button
              type="button"
              class="preset-btn"
              [class.active]="selectedDatePreset === 'last30'"
              (click)="applyDatePreset('last30')"
            >
              Last 30 Days
            </button>
            <button
              type="button"
              class="preset-btn"
              [class.active]="selectedDatePreset === 'custom'"
              (click)="applyDatePreset('custom')"
            >
              Custom
            </button>
          </div>

          <!-- Date inputs row -->
          <div class="grid grid-cols-2 gap-3 mt-6">
            <!-- Start Date Column -->
            <div class="flex flex-col gap-1.5">
              <label
                class="date-input-label text-xs font-semibold text-gray-700 dark:text-gray-300"
              >
                Start Date
              </label>
              <div
                class="date-input-box relative flex items-center justify-between px-3 py-2.5 rounded-lg border cursor-pointer"
                (click)="openDatePicker(startDateInput)"
              >
                <div class="flex items-center gap-2 min-w-0">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="w-4 h-4 text-gray-400 dark:text-gray-400 flex-shrink-0"
                  >
                    <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
                    <line x1="16" x2="16" y1="2" y2="6" />
                    <line x1="8" x2="8" y1="2" y2="6" />
                    <line x1="3" x2="21" y1="10" y2="10" />
                  </svg>
                  <span
                    class="text-xs sm:text-2sm font-medium text-gray-900 dark:text-white truncate"
                  >
                    {{ formatDisplayDate(startDateValue) || "Select date" }}
                  </span>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  class="w-4 h-4 text-gray-400 dark:text-gray-400 flex-shrink-0 ml-1"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
                    clip-rule="evenodd"
                  />
                </svg>
                <input
                  #startDateInput
                  type="date"
                  class="sr-only-date-input"
                  [value]="startDateValue"
                  [max]="endDateValue || null"
                  (change)="onStartDateChange($event)"
                  (click)="openDatePicker(startDateInput)"
                />
              </div>
            </div>

            <!-- End Date Column -->
            <div class="flex flex-col gap-1.5">
              <label
                class="date-input-label text-xs font-semibold text-gray-700 dark:text-gray-300"
              >
                End Date
              </label>
              <div
                class="date-input-box relative flex items-center justify-between px-3 py-2.5 rounded-lg border cursor-pointer"
                (click)="openDatePicker(endDateInput)"
              >
                <div class="flex items-center gap-2 min-w-0">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="w-4 h-4 text-gray-400 dark:text-gray-400 flex-shrink-0"
                  >
                    <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
                    <line x1="16" x2="16" y1="2" y2="6" />
                    <line x1="8" x2="8" y1="2" y2="6" />
                    <line x1="3" x2="21" y1="10" y2="10" />
                  </svg>
                  <span
                    class="text-xs sm:text-2sm font-medium text-gray-900 dark:text-white truncate"
                  >
                    {{ formatDisplayDate(endDateValue) || "Select date" }}
                  </span>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  class="w-4 h-4 text-gray-400 dark:text-gray-400 flex-shrink-0 ml-1"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
                    clip-rule="evenodd"
                  />
                </svg>
                <input
                  #endDateInput
                  type="date"
                  class="sr-only-date-input"
                  [value]="endDateValue"
                  [min]="startDateValue || null"
                  (change)="onEndDateChange($event)"
                  (click)="openDatePicker(endDateInput)"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Footer Actions inside Options Pane -->
        <div
          class="options-footer flex justify-between items-center px-3 py-2 border-t border-gray-200 dark:border-gray-800"
        >
          <span class="text-xs text-gray-400 dark:text-gray-500">
            {{ getSelectedCount(activeField) }} selected
          </span>
          <button
            *ngIf="getSelectedCount(activeField) > 0"
            type="button"
            class="clear-all-link text-xs font-semibold text-gray-500 hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-300"
            (click)="clearFieldFilters(activeField)"
          >
            Clear all
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
